import { QuickSearch } from '@jupiterone/jupiter-web-toolkit';
import React, { useEffect, useState } from 'react';
import { useBooleanState } from 'react-use-object-state';
import { useGraphNetwork } from '../../hooks/useGraphNetwork';
import NodeListMenu from '../NodeListMenu/NodeListMenu';
import { GraphVertex, SelectedNode } from '../types';
import {
  getNodeCanvasPosition,
  getNodeDomPosition,
} from '../utils/getNodePosition';

interface Props {
  selectedNodeId?: string | null;
  reducedVertices: GraphVertex[];
  onSelectNode: (selectedNode: SelectedNode) => void;
}

const GraphSearch = ({
  reducedVertices,
  selectedNodeId,
  onSelectNode,
}: Props) => {
  const [network] = useGraphNetwork();
  const [searchText, setSearchText] = useState<string>('');
  const [shownVertices, setShownVertices] = useState<GraphVertex[]>(
    reducedVertices
  );
  const menuOpen = useBooleanState(false);
  const handleSelectNode = (id: string) => {
    onSelectNode({ id: null, position: [0, 0] });
    const position = getNodeCanvasPosition(id, network);
    network.moveTo({
      position,
      animation: { duration: 500, easingFunction: 'easeInOutQuart' },
      scale: 1,
    });
    setTimeout(() => {
      const { x, y } = getNodeDomPosition(id, network);
      onSelectNode({ id, position: [x, y] });
    }, 750);
  };

  useEffect(() => {
    setShownVertices(
      reducedVertices.filter(
        (v) =>
          (v?.entity?.displayName || '')
            .toUpperCase()
            .indexOf(searchText.toUpperCase()) >= 0
      )
    );
  }, [searchText]);

  useEffect(() => {
    setShownVertices(reducedVertices);
  }, [reducedVertices]);

  return (
    <>
      <QuickSearch
        onSearch={setSearchText}
        focused={true}
        searchOnChange={true}
        placeholder="Search the graph"
        InputProps={{ onBlur: menuOpen.setFalse, onFocus: menuOpen.setTrue }}
        width="100%"
      />
      <NodeListMenu
        vertices={shownVertices}
        open={menuOpen.state}
        selectedNodeId={selectedNodeId}
        onSelectNode={handleSelectNode}
      />
    </>
  );
};

export default GraphSearch;
